import { render, staticRenderFns } from "./structadju.vue?vue&type=template&id=7238e832&scoped=true&"
import script from "./structadju.vue?vue&type=script&lang=js&"
export * from "./structadju.vue?vue&type=script&lang=js&"
import style0 from "./structadju.vue?vue&type=style&index=0&id=7238e832&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238e832",
  null
  
)

export default component.exports